
import { Directive, Injector, Input, NgZone, OnDestroy } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Capacitor } from "@capacitor/core";
import { ModalController, NavController, Platform } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { MqttService } from "ngx-mqtt";
import { Subscription } from "rxjs";
import { filter, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { HiLevelDataFormat } from "src/components/shared-components/enum/enumAddress";
import {
  ClickActionType,
  CustomComponentFunction,
  GuiComponent,
  HAlign,
  ShapeKind,
  VAlign,
} from "src/model/enum/enumCustomInterface";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { TimeRelatedKeywords } from "src/components/shared-components/enum/enumMisc";
import { AddressMethod } from "src/components/shared-components/interfaces/address-method";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";
import { ShapeLayout } from "src/model/interface/shape-layout";
import { StateImage } from "src/model/interface/state-image";
import { AddressService } from "src/service/address.service";
import { AlertService } from "src/service/alert.service";
import { BIGService } from "src/service/big.service";
import { CardsService } from "src/service/cards.service";
import { EventService } from "src/service/event.service";
import { GenericQueryService } from "src/service/generic-query.service";
import { LocalStorageService } from "src/service/local-storage.service";
import { LoggerService } from "src/service/logger.service";
import { MqttClientService } from "src/service/mqtt-client.service";
import { PlantCodeService } from "src/service/plant-code.service";
import { PopupService } from "src/service/popup.service";
import { ScenariosService } from "src/service/scenarios.service";
import { SupervisionService } from "src/service/supervision.service";
import { SystemRouterService } from "src/service/system-router.service";
import { TranslationService } from "src/service/translation.service";
import { UtilityService } from "src/service/utility.service";
import { ValidListHandlerService } from "src/service/valid-list-handler.service";
import { listChart } from "src/state/selectors/chart.selector";
import { clientSettings } from "src/state/selectors/client-settings.selectors";
import { selectedPlant } from "src/state/selectors/plant.selectors";
import { serverSettings } from "src/state/selectors/server-settings-selector";
import { ClientSettings } from "../client-settings";
import { EnumStringConverter } from "../../../components/shared-components/enum/enum-string-converter";
import { Chart } from "../general classes/chart";
import { KeywordTextFormatterAdapter } from "../general classes/keyword-text-formatter-adapter";
import { Plant } from "../general classes/plant";
import { Scenario } from "../general classes/scenario";
import { Supervision } from "../general classes/supervision";
import { Settings } from "../settings";
import { Address } from "../../../components/shared-components/class/component-classes/address";
import { SupervisionComponentAPI } from "./supervision-component-api";

/**
 * Giorgia - GenericGui contains some informations that are in almost all the component.
 * we need to check if the properties here are the right one
 */
@Directive()
export class GenericBasicGUI implements OnDestroy, iTranslation, iEvent {
  protected _logContext = "Generic-basic-gui";

  private style: any;
  private styleChild: any;

  // Used to handle blink/autoOn/autoOff //
  private _BlinkInterval: ReturnType<typeof setInterval>;
  private _AutoOnInterval: ReturnType<typeof setInterval>;
  private _AutoOffInterval: ReturnType<typeof setInterval>;
  private _blinkOn: boolean = false;

  private _firstLoad: boolean = true;
  private _textOnControl: boolean = true;
  private _bitMask: string = "";

  //#region Subcriptions to "_store.select(...)" Observables
  private _subscriptionSettings: Subscription = null;
  protected clientSettingSubscription: Subscription = null;
  protected currentPlantSubscription: Subscription = null;
  //#endregion

  private _subscriptionSupervision: Subscription = null;
  private _chartSubscription: Subscription = null;

  private _subscriptionAddressUpdate: Subscription = null;
  private _translateSubscription: Subscription = null;

  private _intervalRefreshUrl: any = null;
  private _timerCamera: any = null;

  private _commandAddress: Address = null;
  private _commandAddress2: Address = null;
  private _currentScenario: Scenario = null;

  private _cursor: string = "default";
  protected _settings: Settings = null;

  private _currentTimeKeyWordValues: Array<string> = null;
  private _timeRelatedKeywords = TimeRelatedKeywords;

  private _areTimeKeywordsSync: boolean = false;

  //#region  Translation label
  private _lblMOp: string = "Operazione";
  private _lblOp2: string =
    "Seleziona l'operazione da effettuare sull'indirizzo";
  private _lblRead: string = "Leggi";
  private _lblWrite: string = "Scrivi";
  private _lblWriteAddress: string = "Scrittura indirizzo";
  private _lblValueToWrite: string = "Valore da scrivere";
  private _lblReadOnlyObject: string = "";
  private _lblReadOnlyObjectExplain: string = "";
  private _lblRequestConfirm: string = "";
  private _lblRequestConfirmCommandExecution: string = "";

  protected lblAttention: string = "";
  protected lblScenarioDeleted: string = "";
  //#endregion
  protected currentSupervision: Supervision = null;
  protected currentPlant: Plant = null;
  protected keywordTextFormatterAdapter: KeywordTextFormatterAdapter = null;
  protected timeKeyWordInterval: any = null;
  protected currentChart: Chart = null;
  protected currentClientSetting: ClientSettings = null;
  protected modalController: ModalController = null;
  protected supervisionService: SupervisionService = null;
  protected listSupervision: Array<Supervision> = null;
  protected storageService: LocalStorageService = null;
  protected addressService: AddressService = null;
  protected platform: Platform = null;
  protected utilityService: UtilityService = null;
  protected popupService: PopupService = null;
  protected eventService: EventService = null;
  protected mqttService: MqttClientService = null;
  protected scenarioService: ScenariosService;
  protected alertService: AlertService = null;
  protected bigService: BIGService = null;
  protected translateService: TranslationService = null;
  protected cardsService: CardsService = null;
  protected translateServiceTraductionService: TranslateService = null;
  protected systemRouterService: SystemRouterService = null;
  protected navController: NavController = null;
  protected ngZone: NgZone = null;
  protected store: Store = null;
  protected domSanitizer: DomSanitizer = null;
  protected mqttNativeService: MqttService = null;
  protected validListHandlerService: ValidListHandlerService = null;
  protected genericQueryService: GenericQueryService = null;
  protected plantCodeService: PlantCodeService = null;

  protected loggerService: LoggerService;

  protected stateAddress: Address = null;
  protected readOnly: boolean = false;
  protected clickAction: string = "";
  protected readOnlyCommand2: boolean = false;
  protected showRequestConfirmAction: boolean = false;
  protected lineSize: number = 0;
  protected openOnLoad: boolean = false;
  protected backColor: string = "";
  protected backOverlayColor: string = "";
  protected opacity: number = 1;
  protected cameraText: string = "";
  protected accessResetText: string = "...";
  protected accessValidText: string = "";
  protected accessDeniedText: string = "";
  protected accessExpiredCardText: string = "";
  protected accessNotValidCardText: string = "";
  protected accessWrongTimeslotText: string = "";
  protected accessLockCardText: string = "";
  protected accessWrongCalendarText: string = "";
  protected customFunctionObject: number = -1;
  protected customFunctionParam: number = -1;
  protected handleAccessControlLed: boolean = false;
  protected resetTime: number = 0;
  protected instanceGuidDevice: string = "";
  protected idDevice: number = 0;

  /** This flag signals the "scrolling status" of the "ion-container" element in cwhich the instance is contained, so that it could act on it. */
  protected isContainingListScrolling: boolean = false;

  public text: string;
  public welcomeText: string = "";

  public _eventSubscriptions: Array<Subscription> = null;

  // Used to handle ImageState
  public imageUrl: string;
  public imageStretched: boolean;

  // Used to handle ShapeLayout
  public backgroundColor: string = "";
  public transparent: string = "";
  public borderColor: string = "";
  public fontSize: string = "";
  public fontColor: string = "";
  public fontFamily: string = "";
  public bold: string = "";
  public italic: string = "";
  public underline: string = "";
  public strikeout: string = "";
  public showMajorTick: boolean = false;
  public showMinorTick: boolean = false;

  public cameraImageContent: SafeUrl = "";

  public listViewMode: boolean = false;
  public cssCustomComponetClass: string = "";
  public refreshInterval: number = 0;
  public customComponentFunction: CustomComponentFunction =
    CustomComponentFunction.NONE;

  /**
   * ComponentAPI: the object returned by the API
   */
  @Input() ComponentAPI: SupervisionComponentAPI = null;
  @Input() ShowingInDesktopVersion: boolean = true;
  @Input() hAlignment: HAlign;
  @Input() boldForced: boolean;

  /**
   * Giorgia - // //
   * @param injector The injector param is used by the parent classes to inject the services that they needed:
   * using this trick if this class needs more specific services I don't need to inject all of them in the son class,
   * but I can do the injection here.
   */
  constructor(private injector: Injector) {
    this.injectRequiredService(injector);

    this.loadTranslation();
    this.subscribeTranslationEvent();
    this.subscribeEvents();

    //V2
    this.subscribeSettingServiceData();
    this.loadSelectedPlant();

    this._subscriptionSettings = this.store
      .select(serverSettings)
      .subscribe((setting: Settings) => {
        this._settings = setting;
      });

    this.supervisionService.listSupervision
      .pipe(
        filter((supervision) => supervision !== null),
        map((listSupervision: Array<any>) => {
          const supervisionTypedList: Supervision[] = listSupervision.map(
            (supervision) => new Supervision(supervision)
          );

          return supervisionTypedList;
        })
      )
      .subscribe((lSupervision: Array<Supervision>) => {
        this.listSupervision = lSupervision;
      });

    if (this.currentClientSetting) {
      this.listViewMode = this.currentClientSetting.supervisionListViewMode;
    }

    this.scenarioService.Init();
  }

  ngOnDestroy() {
    //Moved code to onDestroyChildren()
  }

  /**
   * This method contains all the operations that must be executed when the ts components which extend this class are destroyed.
   *
   * NOTE: this method MUST be invoked inside the "ngOnDestroy()" of ALL the child-classes.
   */
  protected onDestroyChildren() {
    if (this._intervalRefreshUrl) {
      clearInterval(this._intervalRefreshUrl);
    }

    if (this._subscriptionSettings) {
      this._subscriptionSettings.unsubscribe();
    }

    if (
      this._subscriptionSupervision != undefined &&
      this._subscriptionSupervision != null
    ) {
      this._subscriptionSupervision.unsubscribe();
    }

    if (
      this._chartSubscription != undefined &&
      this._chartSubscription != null
    ) {
      this._chartSubscription.unsubscribe();
    }

    if (this._subscriptionAddressUpdate)
      this._subscriptionAddressUpdate.unsubscribe();

    if (this._translateSubscription) {
      this._translateSubscription.unsubscribe();
    }

    if (this.clientSettingSubscription) {
      this.clientSettingSubscription.unsubscribe();
    }

    if (this.currentPlantSubscription) {
      this.currentPlantSubscription.unsubscribe();
    }

    if (this._timerCamera) {
      clearInterval(this._timerCamera);

      this._timerCamera = null;
    }

    if (this.timeKeyWordInterval) {
      clearInterval(this.timeKeyWordInterval);
      this.timeKeyWordInterval = null;
    }

    this.unsubscribeEvents();
  }

  /**
   * Return if the app runs as a native app (Capacitor), rather than in a browser
   *
   * @returns
   */
  public isCordova() {
    return Capacitor.isNativePlatform();
  }

  //#region Translation
  public loadTranslation(): void {
    this.translateServiceTraductionService
      .get([
        "dictionary.operation",
        "dictionary.operationOnAddress",
        "dictionary.read",
        "dictionary.write",
        "dictionary.writeAddress",
        "dictionary.valueToWrite",
        "dictionary.attention",
        "dictionary.scenarioDeletedExpain",
        "dictionary.readOnlyObject",
        "dictionary.readOnlyObjectExplain",
        "dictionary.requstConfirm",
        "dictionary.requestConfirmCommandExceution",
      ])
      .subscribe((translation) => {
        this._lblMOp = translation["dictionary.operation"];
        this._lblOp2 = translation["dictionary.operationOnAddress"];
        this._lblRead = translation["dictionary.read"];
        this._lblWrite = translation["dictionary.write"];
        this._lblWriteAddress = translation["dictionary.writeAddress"];
        this._lblValueToWrite = translation["dictionary.valueToWrite"];
        this.lblAttention = translation["dictionary.attention"];
        this.lblScenarioDeleted =
          translation["dictionary.scenarioDeletedExpain"];
        this._lblReadOnlyObject = translation["dictionary.readOnlyObject"];
        this._lblReadOnlyObjectExplain =
          translation["dictionary.readOnlyObjectExplain"];
        this._lblRequestConfirm = translation["dictionary.requstConfirm"];
        this._lblRequestConfirmCommandExecution =
          translation["dictionary.requestConfirmCommandExceution"];
      });

    moment.locale(this.translateServiceTraductionService.getCurrentLang());
  }

  public subscribeTranslationEvent() {
    this._translateSubscription =
      this.translateServiceTraductionService.onLangChange.subscribe(() => {
        this.loadTranslation();

        this.TextDataChange();
      });
  }
  //#endregion

  /**
   * AB: Subscription to mqtt value change inside address service
   */
  public subscribeAddressChange() {
    this.stateAddress = this.addressService.getAddressByInstanceGUIDAndAddress(
      this.ComponentAPI.properties["InstanceGUIDState"],
      this.ComponentAPI.properties["AddressState"]
    );

    this._commandAddress =
      this.addressService.getAddressByInstanceGUIDAndAddress(
        this.ComponentAPI.properties["InstanceGUIDCommand"],
        this.ComponentAPI.properties["AddressCommand"]
      );
    if (
      this.ComponentAPI.properties["InstanceGUIDCommand2"] != "" &&
      this.ComponentAPI.properties["AddressCommand2"] != ""
    ) {
      this._commandAddress2 =
        this.addressService.getAddressByInstanceGUIDAndAddress(
          this.ComponentAPI.properties["InstanceGUIDCommand2"],
          this.ComponentAPI.properties["AddressCommand2"]
        );
    }

    // Check if _subscriptionAddressUpdate is falsy (null or undefined)
    if (!this._subscriptionAddressUpdate) {
      this._subscriptionAddressUpdate = this.addressService.addressUpdate
        .pipe(filter((address) => address !== null))
        .pipe(
          filter(
            (address) =>
              address.address ===
              this.ComponentAPI.properties["AddressState"] &&
              address.instanceGUID ===
              this.ComponentAPI.properties["InstanceGUIDState"]
          )
        )
        .subscribe((address: Address) => {
          this.loggerService.log(
            LogLevel.LOG_INFO,
            this._logContext,
            "_addressService",
            "addressUpdate",
            "Address update for: " +
            address.instanceGUID +
            "_" +
            address.address
          );

          this.stateAddress = address;
          this.DataChange();
        });
    }
  }

  /**
   * Load current supervision releated to Supervision property
   */
  private subscribeCurrentSupervision(): void {
    var splitted = this.ComponentAPI.properties["Supervision"].split("|", 2);

    this._subscriptionSupervision = this.supervisionService.listSupervision
      .pipe(filter((supervisions) => supervisions != null))
      .subscribe((supervisions: Array<Supervision>) => {
        if (splitted.length === 1) {
          this.currentSupervision = supervisions.find(
            (supervision) => supervision.id === parseInt(splitted[0])
          );
        } else {
          this.currentSupervision = supervisions.find(
            (supervision) =>
              supervision.id === parseInt(splitted[0]) &&
              supervision.idEnvironment === parseInt(splitted[1])
          );
        }
      });
  }

  /**
   * GF: Used in Scenario button to change the image of the button on the basis of the running of the scenario
   */
  private subscribeScenarioRunningChange() {
    if (parseInt(this.ComponentAPI.properties["Scenario"]) > 0) {
      this.scenarioService.scenarioList
        .pipe(filter((result) => result !== null))
        .subscribe((scenarios) => {
          this._currentScenario = scenarios.find(
            (scenario) =>
              scenario.id === parseInt(this.ComponentAPI.properties["Scenario"])
          );
          if (this._currentScenario) {
            this._cursor = "pointer";
          }
          this.DataChange();
        });
    }
  }

  /**
   * Subscribe chart info
   */
  private subscribeChartInfo(): void {
    if (parseInt(this.ComponentAPI.properties["Chart"]) > 0) {
      this._chartSubscription = this.store
        .select(listChart)
        .pipe(
          filter(
            (listChartObject: GenericStoreApiData) => listChartObject !== null
          ),
          filter(
            (listChartObject: GenericStoreApiData) => listChartObject.loaded
          ),
          map(
            (listChartObject: GenericStoreApiData) =>
              listChartObject.data?.data || []
          )
        )
        .subscribe((listCharts: Array<Chart>) => {
          this.currentChart = listCharts.find(
            (chart: Chart) =>
              chart.id === parseInt(this.ComponentAPI.properties["Chart"])
          );

          this.loadChartTitle();
        });
    }
  }

  /**
   * Subsribe to public Observable "clientSettings" of "settings.service", which propagates the info about the general app
   * -related settings as defined for this device; it will also emit each time these settings are changed.
   */
  protected subscribeSettingServiceData(): void {
    this.clientSettingSubscription = this.store
      .select(clientSettings)
      .pipe(filter((clientSetting) => clientSetting !== null))
      .subscribe((clientSettings: ClientSettings) => {
        this.currentClientSetting = clientSettings;
      });
  }

  /**
   * Laod current plant
   */
  protected loadSelectedPlant(): void {
    this.currentPlantSubscription = this.store
      .select(selectedPlant)
      .pipe(filter((selectedPlant) => selectedPlant !== null))
      .subscribe((selectedPlant: Plant) => {
        this.currentPlant = selectedPlant;
      });
  }

  /**
   * For each property of the component is called its function
   * @param style
   */
  protected HandleProperties(style: any, styleChild: any) {
    this.style = style;
    this.styleChild = styleChild;

    if (this._firstLoad) {
      if (this.ComponentAPI != null) {
        if (
          this.ComponentAPI.properties["InstanceGUIDState"] ||
          this.ComponentAPI.properties["AddressState"]
        ) {
          this.subscribeAddressChange();
        }

        if ("Scenario" in this.ComponentAPI.properties) {
          this.subscribeScenarioRunningChange();
        }

        if ("Supervision" in this.ComponentAPI.properties) {
          this.subscribeCurrentSupervision();
        }

        if ("Chart" in this.ComponentAPI.properties) {
          this.subscribeChartInfo();
        }
      }
      //
      Object.keys(this.ComponentAPI.properties).forEach((property, index) => {
        if (this[property.trim()]) {
          this[property.trim()](this.ComponentAPI.properties[property]);
        } else {
          this.loggerService.log(
            LogLevel.LOG_INFO,
            this._logContext,
            this._logContext,
            "HandleProperties()",
            " unhandled property: " + property
          );
        }
      }, this);

      this.DataChange();
      this._firstLoad = false;
    }
    return [this.style, this.styleChild];
  }

  /**
   * Handle "HandleControlAccessLed" property
   *
   * @param value Value property
   */
  protected HandleControlAccessLed(value: string): void {
    this.handleAccessControlLed = this.toBool(
      this.ComponentAPI.properties["HandleControlAccessLed"]
    );
  }

  /**
   * Handle reset time property
   *
   * @param value Property value
   */
  protected ResetTime(value: string): void {
    this.resetTime = parseInt(this.ComponentAPI.properties["ResetTime"], 10);
  }

  /**
   * Handle instance guid device property
   *
   * @param value Property value
   */
  protected InstanceGUIDDevice(value: string): void {
    this.instanceGuidDevice = value;
  }

  /**
   * Handle id device property
   *
   * @param value Property values
   */
  protected IDDevice(value: string): void {
    this.idDevice = Number(value) || 0;
  }

  private NormalImage(value: string) { }

  private NormalImageFormat(value: string) { }

  private NormalImageStretch(value: string) { }

  protected PressedImage(value: string) { }

  private PressedImageFormat(value: string) { }

  private PressedImageStretch(value: string) { }

  private RunningImageFormat(value: string) { }

  private Orientation(value: string) { }

  protected Image(value: string) {
    if (value !== "") {
      this.imageUrl =
        environment.httpServerRoot + "/Downloads/Image_" + value + ".png"; // + this.ComponentAPI.properties["NormalImageFactor"];
    }
  }

  protected ImageStretch(value: string) {
    if (value.toUpperCase() == "TRUE") {
      this.style["background-size"] = "cover";
      this.style["object-fit"] = "cover";
    } else {
      this.style["background-size"] = "initial";
    }
  }

  /**
   * Handle RefreshInterval property
   *
   * @param intervalTick Interval tick for refresh
   */
  protected RefreshInterval(intervalTick: string) {
    this.loggerService.log(
      LogLevel.LOG_INFO,
      this._logContext,
      this._logContext,
      "RefreshInterval()",
      "URL: " +
      this.ComponentAPI.properties["URL"] +
      " ||| Interval: " +
      intervalTick
    );

    this.refreshInterval = Number(intervalTick);

    if (this.ComponentAPI.properties["URL"] && parseInt(intervalTick) > 0) {
      this.reloadImageContent();

      this._timerCamera = setInterval(() => {
        this.reloadImageContent();
      }, 1000 * parseInt(intervalTick));
    }
  }

  protected UsernameAuthentication(value: string) { }

  protected PasswordAuthentication(value: string) { }

  /**
   * Set URL With specific value
   *
   * @param value
   */
  protected URL(value: string) {
    if (value !== "") {
      if (
        this.ComponentAPI.properties["UsernameAuthentication"] === "" &&
        this.ComponentAPI.properties["PasswordAuthentication"] === ""
      ) {
        this.imageUrl = value;
      } else {
        this.imageUrl =
          " https://" +
          this.ComponentAPI.properties["UsernameAuthentication"] +
          ":" +
          this.ComponentAPI.properties["PasswordAuthentication"] +
          "@" +
          value;
      }
    }
  }

  protected Proportional(value: string) {
    if (value.toUpperCase() == "TRUE") {
      this.style["background-repeat"] = "no-repeat";
      this.style["background-size"] = "contain";
    }
  }

  /**
   * Handle bit mask vvlaue
   *
   * @param value
   */
  private BitMask(value: string) {
    this._bitMask = value;
  }

  /**
   * Handle property OpenOnLoad
   *
   * @param value
   */
  private OpenOnLoad(value: string): void {
    this.openOnLoad = value.toUpperCase() === "TRUE";
  }

  private AddressState(value: string) { }

  private Function(value: string) { }

  private InstanceGUIDCommand(value: string) { }

  private AddressCommand(value: string) { }

  /**
   * Set readonly value by string component value
   *
   * @param value Value to string
   */
  private ReadOnly(value: string) {
    this.readOnly = value === "1";
  }

  /**
   * Set readonly command 2 value by string component value
   *
   * @param value Value to string
   */
  private ReadOnlyCommand2(value: string) {
    this.readOnlyCommand2 = value === "1";
  }

  private Password(value: string) { }

  private PasswordProtected(value: string) { }

  private ShowRequestConfirmAction(value: string): void {
    this.showRequestConfirmAction = value === "TRUE";
  }

  /**
   * Handle click action property.
   *
   * @param value Click action value
   */
  protected ClickAction(value: string) {
    this.clickAction = value;

    if (value !== ClickActionType.NO_ACTIONS && !this.readOnly) {
      this._cursor = "pointer";
    } else {
      this._cursor = "default";
    }
  }

  protected DblClickAction(value: string) { }

  /**
   * Get the value of the text and generate the correct value on the basis of the address associated
   * @param value Value of the text on the supervisione component
   */
  protected Text(value: string) {
    if (value) {
      this.keywordTextFormatterAdapter = new KeywordTextFormatterAdapter(
        value,
        this._settings.DefaultDecimalDigits,
        this._settings.UseThousandSeparatorForValueKeyword,
        this.translateService
      );
    }
  }

  /**
   * Reset access text.
   * For older version, reset text must be three dots
   *
   * @param value Value property
   */
  protected ResetAccessText(value: string): void {
    this.accessResetText = value || "...";
  }

  /**
   * Valid access text
   *
   * @param value Value property
   */
  protected ValidAccessText(value: string): void {
    this.accessValidText = value;
  }

  /**
   * Access denied text
   *
   * @param value Value property
   */
  protected AccessDeniedText(value: string): void {
    this.accessDeniedText = value;
  }

  /**
   * Expired card text
   *
   * @param value Value property
   */
  protected ExpiredCardText(value: string): void {
    this.accessExpiredCardText = value;
  }

  /**
   * Not valid card text
   *
   * @param value Value property
   */
  protected NotValidCardText(value: string): void {
    this.accessNotValidCardText = value;
  }

  /**
   * Wrong timeslot text
   *
   * @param value Value property
   */
  protected WrongTimeslotText(value: string): void {
    this.accessWrongTimeslotText = value;
  }

  /**
   * Locked card text
   *
   * @param value Value property
   */
  protected LockedCardText(value: string): void {
    this.accessLockCardText = value;
  }

  /**
   * Wrong calendar text
   *
   * @param value  Value property
   */
  protected WrongCalendarText(value: string): void {
    this.accessWrongCalendarText = value;
  }

  private formatThousandSeprator(value) {
    return value;
  }

  /**
   * Handle show text on control property by string value
   *
   * @param value Property value
   */
  private ShowText(value: string) {
    this._textOnControl = value.toUpperCase() === "TRUE";
    if (!this._textOnControl) {
      this.text = "";
    }
  }

  protected AssignFont(
    style,
    color: string,
    family: string,
    size: string | number,
    bold: string | boolean,
    italic: string | boolean,
    underline: string | boolean,
    strikeout: string | boolean
  ) {
    this.AssignFontColor(style, color);
    this.AssignFontFamily(style, family);
    this.AssignFontSize(style, size);
    this.AssignBold(style, bold);
    this.AssignItalic(style, italic);
    this.AssignDecorator(style, underline, strikeout);
  }

  protected AssignFontColor(style, color: string) {
    if (color) style["color"] = color;
  }

  protected AssignFontFamily(style, family: string) {
    if (family) style["font-family"] = family + ", Arial"; //Adding fallback font in case if primary font not installed on device
  }

  protected AssignFontSize(style, size: string | number) {
    if (size)
      style["font-size"] =
        size.toString().replace("px", "").replace("pt", "") + "pt";
  }

  protected AssignBold(style, bold: string | boolean) {
    if (bold) {
      if (this.toBool(bold)) style["font-weight"] = "bold";
      else style["font-weight"] = "normal";
    }
  }

  protected AssignItalic(style, italic: string | boolean) {
    if (italic) {
      if (this.toBool(italic)) style["font-style"] = "italic";
      else style["font-style"] = "normal";
    }
  }

  protected AssignDecorator(
    style,
    underline: string | boolean,
    strikeout: string | boolean
  ) {
    let fontDecorator = "none";

    if (underline) {
      if (this.toBool(underline)) fontDecorator = "underline";
    }

    if (strikeout) {
      if (this.toBool(strikeout)) {
        if (fontDecorator === "none") fontDecorator = "line-through";
        else fontDecorator += " line-through";
      }
    }

    style["text-decoration"] = fontDecorator;
  }

  /**
   * Line size gauge
   *
   * @param value Value of property
   */
  private LineSize(value: string): void {
    this.lineSize = Number(value);
  }

  /**
   * Show minor tick
   *
   * @param value Value string API
   */
  private ShowFirstTick(value: string): void {
    this.showMinorTick = value.toString().toUpperCase() === "TRUE";
  }

  /**
   * Show major tick
   *
   * @param value Value string API
   */
  private ShowLastTick(value: string): void {
    this.showMajorTick = value.toString().toUpperCase() === "TRUE";
  }

  private ReadAddressStateAfterWrite(value: string) {
    // evalutation inside SendCommand function
  }

  /** Handled in Underline function */
  private Strikeout(value: string) { }

  //#region Position
  private Left(value: string) {
    if (this.ShowingInDesktopVersion) {
      this.style["position"] = "absolute";
      if (!value.includes("px")) {
        value += "px";
      }
      this.style["left"] = value;
    } else {
      this.style["position"] = "relative";
    }
  }

  private Top(value: string) {
    if (this.ShowingInDesktopVersion) {
      this.style["position"] = "absolute";
      if (!value.includes("px")) {
        value += "px";
      }
      this.style["top"] = value;
    } else {
      this.style["position"] = "relative";
    }
  }

  protected Width(value: string) {
    if (
      this.ShowingInDesktopVersion ||
      !this.ComponentAPI.code.includes("Button")
    ) {
      if (!value.includes("px")) {
        value += "px";
      }
      this.style["width"] = value;
    } else {
      this.style["width"] = "48px";
    }
  }

  private Height(value: string) {
    if (
      this.ShowingInDesktopVersion ||
      !this.ComponentAPI.code.includes("Button")
    ) {
      if (!value.includes("px")) {
        value += "px";
      }
      this.style["height"] = value;
    } else {
      this.style["height"] = "48px";
    }
  }

  protected AssignFlexAlignment(
    style,
    hAlignment: string | number,
    vAlignment: string | number
  ) {
    this.AssignFlexHAlignment(style, hAlignment);
    this.AssignFlexVAlignment(style, vAlignment);
  }

  /**
   * Handle Horizontal alignment in component
   *
   * @param hAlignment string value of horizontal alignment
   */
  protected AssignFlexHAlignment(style, hAlignment: string | number) {
    switch (parseInt(hAlignment.toString(), 10)) {
      case HAlign.LEFT:
        style["justify-content"] = "flex-start";
        style["text-align"] = "left";
        break;
      case HAlign.CENTER:
        style["justify-content"] = "center";
        style["text-align"] = "center";
        break;
      case HAlign.RIGHT:
        style["justify-content"] = "flex-end";
        style["text-align"] = "right";
        break;
      default:
        break;
    }
  }

  /**
   * Handle vertical alignment in supervision component
   *
   * @param vAlignment Value vertical alignment received
   */
  protected AssignFlexVAlignment(style, vAlignment: string | number) {
    switch (parseInt(vAlignment.toString(), 10)) {
      case VAlign.UP:
        style["align-items"] = "flex-start";
        break;
      case VAlign.MIDDLE:
        style["align-items"] = "center";
        break;
      case VAlign.DOWN:
        style["align-items"] = "flex-end";
        break;
      default:
        break;
    }
  }

  /**
   * Handle Horizontal alignment in supervision list component
   *
   * @param value string value of horizontal alignment
   */
  protected HAlignmentList(value: string) {
    switch (parseInt(value, 10)) {
      case HAlign.LEFT:
        this.style["justify-content"] = "flex-start";
        this.style["text-align"] = "left";
        break;
      case HAlign.CENTER:
        this.style["justify-content"] = "center";
        this.style["text-align"] = "center";
        break;
      case HAlign.RIGHT:
        this.style["justify-content"] = "flex-end";
        this.style["text-align"] = "right";
        break;
      default:
        break;
    }
  }

  //#endregion

  //#region other
  GetBlinkFrequency() {
    let result = 0;
    if (this.ComponentAPI.properties["BlinkFrequency"]) {
      if (this.ComponentAPI.properties["BlinkFrequency"] !== "5") {
        result =
          1000 / parseInt(this.ComponentAPI.properties["BlinkFrequency"]);
      } else {
        result = 2000;
      }
    }
    return result;
  }
  ////#endregion

  //#region Color
  protected AssignBackgroundColor(
    style,
    showBackground: string | boolean,
    transparent: string | boolean,
    backColor: string
  ): void {
    let background = backColor;

    if (showBackground) {
      if (!this.toBool(showBackground)) background = "transparent";
    }

    if (transparent) {
      if (this.toBool(transparent)) background = "transparent";
    }

    if (background) style["background-color"] = background;
  }

  protected toBool(value: any) {
    return (
      value.toString() === "1" || value.toString().toUpperCase() === "TRUE"
    );
  }

  /**
   * Set overlay bacground colour.
   */
  private BackOverlayColor(value: string): void {
    this.backOverlayColor = value;
  }

  private Opacity(value: string): void {
    this.opacity = Number(value.replace(",", "."));
  }

  private CameraText(value: string): void {
    this.cameraText = value;
  }

  private ShowBackground(value: string) { }

  private AssignBorder(color: string, width: string | number) {
    this.AssignBorderColor(color);
    this.AssignBorderWidth(width);
  }

  private AssignBorderColor(color: string) {
    if (color) this.style["border-color"] = color;
  }

  private AssignBorderWidth(width: string | number) {
    if (width) {
      this.style["border-width"] = width.toString().replace("px", "") + "px";
      if (parseInt(width.toString().replace("px", ""), 10) > 0)
        this.style["border-style"] = "solid";
      else this.style["border-style"] = "none";
    }
  }

  private Transparent(value: string) { }

  private Kind(value: string) {
    switch (parseInt(value, 10)) {
      case ShapeKind.ELLIPSE:
        this.style["border-radius"] = "50%";
        break;
      default:
        if (this.ComponentAPI.properties["RoundCorner"] === "TRUE") {
          this.style["border-radius"] = "5%";
        } else {
          this.style["border-radius"] = "0%";
        }
        break;
    }
  }

  private RoundCorner(value: string) {
    // Already handled in ShapeKind property
  }
  //#endregion

  /**
   * Custom function property
   *
   * @param value
   */
  private Customfunction(value: string) {
    this.customComponentFunction = parseInt(value, 10);
  }

  /**
   * Custom function object
   *
   * @param value Value property
   */
  private CustomFunctionObject(value: string) {
    this.customFunctionObject = parseInt(value, 10);
  }

  /**
   * Custom function paraeter
   *
   * @param value Value property
   */
  private CustomFunctionParam(value: string) {
    this.customFunctionParam = parseInt(value, 10);
  }

  //#region Supervision
  private Supervision(value: string) {
    if (value.trim() !== "" && parseInt(value) > 0) {
      this._cursor = "pointer";
    } else {
      this._cursor = "default";
    }
  }
  //#endregion

  //#region Images
  private DefaultImageUsed(value: string) { }

  //#endregion
  private OnLeaveEdit() { }

  OnEnterEdit() { }

  SetGUIProperties() { }

  OnEnterTab() { }

  OnLeaveTab() { }

  /**
   * AB: Function that calculate urlImage value in case of button pression from the user
   *
   */
  public SetPressedImage(pressed: boolean) {
    if (pressed) {
      if (parseInt(this.ComponentAPI.properties["PressedImage"]) > 0) {
        if (
          !this.ComponentAPI.properties["ClickAction"] ||
          (this.ComponentAPI.properties["ClickAction"] &&
            this.ComponentAPI.properties["ClickAction"] !==
            ClickActionType.NO_ACTIONS)
        ) {
          this.imageStretched =
            this.ComponentAPI.properties["PressedImageStretch"];
          this.imageUrl =
            environment.httpServerRoot +
            "/Downloads/Image_" +
            this.ComponentAPI.properties["PressedImage"] +
            ".png"; // + this.ComponentAPI.properties["NormalImageFactor"];

          this.setCurrentImage(this.imageUrl, this.imageStretched);
        }
      } else {
        // nothing?
      }
    } else {
      this.ImageDataChange();
    }
  }

  /**
   * GF: used to apply a state image
   * @param stateImage state image to apply
   */
  public AssignStateImage(stateImage: any) {
    this.imageUrl =
      environment.httpServerRoot +
      "/Downloads/Image_" +
      stateImage.idImage +
      ".png"; // + this.ComponentAPI.properties["NormalImageFactor"];
    this.imageStretched = stateImage.stretchImage;
  }

  /**
   * GF: to avoid flickring on first pressed image (due to the time spended to downloading the image from the server)
   * when the component is load the first time the pressed image is downloaded
   */
  private PreLoadImages() {
    if (parseInt(this.ComponentAPI.properties["PressedImage"]) > 0) {
      let imgPressed = new Image();
      imgPressed.src =
        environment.httpServerRoot +
        "/Downloads/Image_" +
        this.ComponentAPI.properties["PressedImage"] +
        ".png";
    }
  }

  /**
   * AB: Function that calculate urlImage value. It check first if there's NormalImage; then check AB:out
   * StateImages existance (in this case overwrite urlImage value)
   */
  protected ImageDataChange() {
    if (this._firstLoad) this.PreLoadImages();

    // check if there's NormalImage
    if (parseInt(this.ComponentAPI.properties["NormalImage"]) > 0) {
      this.imageUrl =
        environment.httpServerRoot +
        "/Downloads/Image_" +
        this.ComponentAPI.properties["NormalImage"] +
        ".png"; // + this.ComponentAPI.properties["NormalImageFactor"];
      this.imageStretched = this.ComponentAPI.properties["NormalImageStretch"];
    }

    // check if there're stateImages
    if (this.ComponentAPI.stateImages.length > 0 && this.stateAddress) {
      let currentValue = this.stateAddress.lastValue.toLowerCase();

      //GF: bitmask handling
      if (
        this.stateAddress.hiLevelDataFormat ===
        EnumStringConverter.hiLevelDataFormatToStringEnum(
          HiLevelDataFormat.INTEGER
        ) &&
        this.ComponentAPI.properties["BitMask"] !== ""
      ) {
        currentValue = this.handleBitMask(currentValue);
      }

      for (const stateImage of this.ComponentAPI.stateImages) {
        if (this.isValueIncludedIntoRange(stateImage, currentValue)) {
          this.AssignStateImage(stateImage);
          break;
        }
      }

      /** GF: blink: when the state is <> 0 start the blink: each blinkFrequency
       * time change the state image from on to off */
      if (this._BlinkInterval && this._BlinkInterval !== null) {
        clearInterval(this._BlinkInterval);
        this._BlinkInterval = null;
      }

      if (
        this.ComponentAPI.properties["Blink"] &&
        this.ComponentAPI.properties["Blink"] === "TRUE" &&
        currentValue !== "0"
      ) {
        this._BlinkInterval = setInterval(() => {
          if (currentValue !== "0") {
            let imageBlinkValue = "0";
            if (!this._blinkOn) {
              imageBlinkValue = "1";
            }
            const blinkImage: any = this.ComponentAPI.stateImages.find(
              (image) => image.value === imageBlinkValue
            );
            if (blinkImage && blinkImage !== null) {
              this.AssignStateImage(blinkImage);
            }
            this._blinkOn = !this._blinkOn;
          }
        }, this.GetBlinkFrequency());
      }

      /** GF: autoOn: when the state changes to 0 start the timer and send on after the timeout (do not send anything)
       */
      if (this._AutoOnInterval && this._AutoOnInterval !== null) {
        clearInterval(this._AutoOnInterval);
        this._AutoOnInterval = null;
      }

      if (
        this.ComponentAPI.properties["AutoOn"] &&
        this.ComponentAPI.properties["AutoOn"] === "TRUE" &&
        currentValue === "0"
      ) {
        this._AutoOnInterval = setInterval(() => {
          const autoOnImage: any = this.ComponentAPI.stateImages.find(
            (image) => image.value === "1"
          );
          if (autoOnImage && autoOnImage !== null) {
            this.AssignStateImage(autoOnImage);
          }
          clearInterval(this._AutoOnInterval);
        }, parseInt(this.ComponentAPI.properties["AutoTimeout"]) * 1000);
      }

      /** GF: autoOff: when the state changes to 1 start the timer and show off after the timeout (do not send anything)
       */
      if (this._AutoOffInterval && this._AutoOffInterval !== null) {
        clearInterval(this._AutoOffInterval);
        this._AutoOffInterval = null;
      }
      if (
        this.ComponentAPI.properties["AutoOn"] &&
        this.ComponentAPI.properties["AutoOn"] === "TRUE" &&
        currentValue === "1"
      ) {
        this._AutoOffInterval = setInterval(() => {
          const autoOffImage: any = this.ComponentAPI.stateImages.find(
            (image) => image.value === "0"
          );
          if (autoOffImage && autoOffImage !== null) {
            this.AssignStateImage(autoOffImage);
          }
          clearInterval(this._AutoOffInterval);
        }, parseInt(this.ComponentAPI.properties["AutoTimeout"]) * 1000);
      }
    } else if (
      this._currentScenario &&
      this._currentScenario !== null &&
      parseInt(this.ComponentAPI.properties["RunningImage"]) > 0 &&
      this._currentScenario.running
    ) {
      this.imageUrl =
        environment.httpServerRoot +
        "/Downloads/Image_" +
        this.ComponentAPI.properties["RunningImage"] +
        ".png"; // + this.ComponentAPI.properties["NormalImageFactor"];
      this.imageStretched = this.ComponentAPI.properties["RunningImageStretch"];
    }

    if (this.imageUrl === "" || this.imageUrl === undefined) {
      this.imageUrl = "";
      this.imageStretched = true;
    }
    this.setCurrentImage(this.imageUrl, this.imageStretched);
  }

  /**
   * Overriden in the upper classes
   * @param urlImage
   * @param stretch
   */
  protected setCurrentImage(urlImage: string, stretch: boolean) { }

  /**
   * GF: change the shape layout based on the value of the stateAddress
   */
  protected ShapeLayoutDataChange() {
    // check if there are shapeLayout
    let shapeLayoutAssigned = false;
    if (this.ComponentAPI.shapeLayout.length > 0 && this.stateAddress) {
      for (const sLayout of this.ComponentAPI.shapeLayout) {
        if (
          this.isValueIncludedIntoRange(sLayout, this.stateAddress.lastValue)
        ) {
          this.assignShapeLayout(sLayout);
          shapeLayoutAssigned = true;
          break;
        }
      }

      if (!shapeLayoutAssigned) this.assignComponentStylebyProperties();
    }
  }

  private assignShapeLayout(shapeLayout: ShapeLayout) {
    this.AssignBackgroundColor(
      this.style,
      null,
      shapeLayout.transparent,
      shapeLayout.backColor
    );

    this.AssignBorderColor(shapeLayout.borderColor);

    this.AssignFont(
      this.style,
      shapeLayout.fontColor,
      shapeLayout.fontName,
      shapeLayout.fontSize,
      shapeLayout.fontBold,
      shapeLayout.fontItalic,
      shapeLayout.fontUnderline,
      shapeLayout.fontStrike
    );
  }

  /**
   * Assign component style by ComponentAPI properties
   */
  private assignComponentStylebyProperties(): void {
    this.style["cursor"] = this._cursor;

    this.AssignBackgroundColor(
      this.style,
      this.ComponentAPI.properties["ShowBackground"],
      this.ComponentAPI.properties["Transparent"],
      this.ComponentAPI.properties["BackColor"]
    );

    this.AssignBorder(
      this.ComponentAPI.properties["BorderColor"],
      this.ComponentAPI.properties["BorderWidth"]
    );

    if (this.ShowingInDesktopVersion) {
      this.AssignFont(
        this.style,
        this.ComponentAPI.properties["FontColor"],
        this.ComponentAPI.properties["FontFamily"],
        this.ComponentAPI.properties["FontSize"],
        this.ComponentAPI.properties["Bold"],
        this.ComponentAPI.properties["Italic"],
        this.ComponentAPI.properties["Underline"],
        this.ComponentAPI.properties["Strikeout"]
      );
    }
  }

  /**
   * Generic datachange component
   */
  protected DataChange(): void {
    this.ImageDataChange();
    this.assignComponentStylebyProperties();

    if (
      this.ComponentAPI.code === GuiComponent.SHAPE ||
      this.ComponentAPI.code === GuiComponent.LABEL
    ) {
      this.ShapeLayoutDataChange();
    }

    if (this.ComponentAPI.code === GuiComponent.GAUGE) {
      this.DataChangeGauge();
    }

    this.TextDataChange();
  }

  /**
   * Handle text data change for all components
   */
  protected TextDataChange(): void {
    let componentText: string = "";

    if (this._textOnControl && this.keywordTextFormatterAdapter) {
      componentText = this.keywordTextFormatterAdapter.replaceText(
        this.stateAddress,
        this._currentScenario,
        this.currentSupervision,
        this.currentChart
      );

      if (this.keywordTextFormatterAdapter.containDateTimeKeyword) {
        this.synchronizeTimeKeywords();
      }
    }

    this.text = componentText;

    this.updateIosVariable(this.text);
  }

  /**
   * Function to overrider to load chart title
   */
  protected loadChartTitle(): void { }

  /**
   * This method set the timer which controls the synchronisation of "time values" in this component's "text" property, or the values which have replaced the "time-related"
   * keywords in the original, "APICOMPONENT"'s "text" property.
   *
   */
  private synchronizeTimeKeywords(): void {
    if (!this._areTimeKeywordsSync) {
      this._areTimeKeywordsSync = true;

      this.timeKeyWordInterval = setInterval(async () => {
        this.TextDataChange();
      }, 1000 * AppSettings.TEMPORAL_KEYWORD_SYNC_DEFAULT_INTERVAL);
    }
  }

  /**
   * Handle data change event for gauge
   */
  protected DataChangeGauge(): void { }

  /**
   * navigate to supervision (get id from property Supervision)
   */
  public navigateToSupervision(jumpSupervision: boolean = false): void {
    if (this.ComponentAPI.properties["Supervision"] !== "") {
      const splitted: string[] = this.ComponentAPI.properties[
        "Supervision"
      ].split("|", 2);

      let idEnvironment = 0;
      if (splitted.length === 2) {
        idEnvironment = parseInt(splitted[1]);
      }
      if (splitted[0].toString() === "-99") {
        //this.systemRouterService.navigateToListSupervisions();

        this.loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          this._logContext,
          "navigateToSupervision()",
          "Supervision button linked to 'PREVIOUS SUPERVISION' "
        );
        this.navController.pop();

        //NOTE: Currently the peculiar case where the "secondLastChild" is constituted by the SAME SUPERVISION presented in "lastChild", but displayed
        //in a different mode (IE. graphical-mode VS list-mode) IS NOT HANDLED.
        /*
        if(jumpSupervision){
            this.ionRouterOutlet.pop(2);
        }else{

        }
        */
      } else if (splitted[0].toString() === "-90") {
        //donothing
      } else {
        if (this.listViewMode) {
          this.systemRouterService.navigateToSupervisionList(
            parseInt(splitted[0]),
            idEnvironment
          );
        } else {
          this.systemRouterService.navigateToSupervisionGraph(
            parseInt(splitted[0]),
            idEnvironment
          );
        }
      }
    }
  }

  /**
   * Handle single click function.
   * If releated command address is not read-only or no action, execute action.
   * If readOnly is true (address command is readonly), show popup read only
   */
  protected async handleSingleClickFunction(): Promise<void> {
    if (
      this.ComponentAPI.properties["ClickAction"] !== ClickActionType.NO_ACTIONS
    ) {
      if (!this.readOnly) {
        const canExecuteCommand: boolean =
          await this.handleOpenPopupRequestConfirmCommandExecution();

        if (canExecuteCommand) {
          this.SendCommand(this.ComponentAPI.properties["ClickAction"]);
        }
      } else {
        this.handleShowReadonlyCommandAlert();
      }
    }
  }

  /**
   * Handle double click function.
   * If releated command address is not read-only or no action, execute action.
   * If readOnly is true (address command is readonly), show popup read only
   */
  protected async handleDoubleClickFunction(): Promise<void> {
    if (
      this.ComponentAPI.properties["DblClickAction"] !==
      ClickActionType.NO_ACTIONS
    ) {
      if (!this.readOnly) {
        const canExecuteCommand: boolean =
          await this.handleOpenPopupRequestConfirmCommandExecution();

        if (canExecuteCommand) {
          this.SendCommand(this.ComponentAPI.properties["DblClickAction"]);
        }
      } else {
        this.handleShowReadonlyCommandAlert();
      }
    }
  }

  /**
   * GF: the function receive the command to send and execute the actions
   * @param command property["ClickAction"], property["DblClickAction"], property["LongPressAction"], property["LongPressRelease"]
   * @param commandAddressIDX ClickAction, ReleaseAction works on command address 1,
   *                          LongPressAction, RetriggerAction works on command address 2
   *                          The default IDX is 1
   * @param checkPassword if true the check of the correct password is done (if necessary);
   *                      this param is false on Retrigger and longPressRelease
   * @param useCommandAsState true only on retriggering command: used to avoid the problem that the status is not
   *                          coming back quickly when the command is retriggerated as an increment/decrement
   */
  public async SendCommand(
    command: string,
    commandAddressIDX = 1,
    checkPassword = true,
    useCommandAsState = false
  ) {
    let passwordOk = true;

    if (checkPassword) {
      passwordOk = await this.isCommandPasswordOk();
    }

    if (passwordOk) {
      let currentCommandAddress = this._commandAddress;

      if (commandAddressIDX === 2 && this._commandAddress2) {
        currentCommandAddress = this._commandAddress2;
      }

      if (currentCommandAddress != null) {
        let proceed = true;
        if (command === ClickActionType.POPUP) {
          let returnData =
            await this.popupService.showModalAddressMethodsAndOpenPrompt(
              currentCommandAddress,
              true,
              currentCommandAddress.hiLevelDataFormat
            );

          if (returnData.action == "") {
            proceed = false;
          } else {
            command = returnData.value;
          }
        }

        if (proceed) {
          switch (command) {
            case ClickActionType.READ:
              if (this.stateAddress != null) {
                this.mqttService.publishAddressRead(
                  this.stateAddress.instanceGUID +
                  "_" +
                  this.stateAddress.address
                );
              }
              break;
            case ClickActionType.NO_ACTIONS:
              // do nothing
              break;
            default:
              // WRITE
              // if the value is void ask the user to prompt the value
              if (command === "" || command === undefined) {
                proceed = false;
              }

              if (proceed) {
                if (!useCommandAsState) {
                  this.mqttService.publishAddressWrite(
                    currentCommandAddress.instanceGUID +
                    "_" +
                    currentCommandAddress.address,
                    this.stateAddress.instanceGUID,
                    this.stateAddress.address,
                    this.stateAddress.lastValue,
                    true,
                    command
                  );
                } else {
                  this.mqttService.publishAddressWrite(
                    currentCommandAddress.instanceGUID +
                    "_" +
                    currentCommandAddress.address,
                    currentCommandAddress.instanceGUID,
                    currentCommandAddress.address,
                    currentCommandAddress.lastValue,
                    true,
                    command
                  );
                }
                // evaluate ReadAddressStateAfterWrite property
                if (
                  this.ComponentAPI.properties["ReadAddressStateAfterWrite"]
                ) {
                  if (
                    this.ComponentAPI.properties[
                      "ReadAddressStateAfterWrite"
                    ].toUpperCase() == "TRUE"
                  ) {
                    let interval = setInterval(function () {
                      //this.SendCommand("#READ");
                      if (this.stateAddress != null) {
                        this.mqttService.publishAddressRead(
                          this.stateAddress.instanceGUID +
                          "_" +
                          this.stateAddress.address
                        );
                      }
                      clearInterval(interval);
                    }, 2000);
                  }
                }
              }
              break;
          }
        }
      }

      /**
       * GF: Check if it has a scenario associated to run or stop the execution
       */
      if (
        this.ComponentAPI.properties["Scenario"] &&
        parseInt(this.ComponentAPI.properties["Scenario"]) > 0 &&
        this._currentScenario
      ) {
        /**
         * -1 = no action
         * 0 = execute
         * 2 = stop
         */
        if (
          parseInt(this.ComponentAPI.properties["ScenarioClickAction"]) === 0
        ) {
          const address =
            AppSettings.INSTANCE_GUID_OMNIA +
            "_Scenario/" +
            this._currentScenario.id +
            "/Execute";
          this.scenarioService.publishAddress(address, "1");
        } else {
          const address =
            AppSettings.INSTANCE_GUID_OMNIA +
            "_Scenario/" +
            this._currentScenario.id +
            "/Stop";
          this.scenarioService.publishAddress(address, "1");
        }
      }

      /**
       * GF: Check if request to change supervision
       */
      if (
        this.ComponentAPI.properties["Supervision"] !== "" &&
        this.ComponentAPI.properties["Supervision"] !== "0" &&
        this.ComponentAPI.properties["Supervision"] !== "-90"
      ) {
        // Move to supervision page
      }
    }
  }

  /**
   * Assign custom component alignment by horizzontal allign type
   *
   * @param hAlignment Align type
   * @returns Value margin to assig to component
   */
  protected assignComponentMarginByAlignment(hAlignment: string): string {
    let margin: string = "";

    switch (parseInt(hAlignment)) {
      case HAlign.RIGHT:
        margin = "0 0 0 auto"; /** right align */
        break;
      case HAlign.LEFT:
        margin = "0 auto 0 0"; /** right align */
        break;
      default: /** right align */
        margin = "0 auto";
        break;
    }

    return margin;
  }

  /**
   * Reload image content by specific component property and specific
   */
  private async reloadImageContent(
    sourceSelector: string = "component-image-"
  ) {
    const myImage = new Image();

    myImage.crossOrigin = ""; // or "anonymous"
    // Call the function with the URL we want to load, but then chain the
    // promise then() method on to the end of it. This contains two callbacks

    try {
      const imsageCamera = await this.utilityService.getBlobImage(
        this.ComponentAPI.properties["URL"],
        this.ComponentAPI.properties["UsernameAuthentication"],
        this.ComponentAPI.properties["PasswordAuthentication"]
      );

      this.cameraImageContent =
        this.domSanitizer.bypassSecurityTrustUrl(imsageCamera);
    } catch (exception) {
      this.loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "reloadImageContent()",
        "Error: " + exception
      );
    }
  }

  /**
   * Handle show popup for readonly address releated with all component
   */
  protected async handleShowReadonlyCommandAlert(): Promise<void> {
    await this.alertService.presentAlertOk(
      this._lblReadOnlyObject,
      "",
      this._lblReadOnlyObjectExplain
    );
  }

  /**
   * Handle show popup to execute action command if "ShowRequestConfirmAction" is set to TRUE.
   * Show popup request confirm commandi. If shown is set, it's shown before command execution
   *
   * @returns Boolean whoo handle next command execution
   */
  protected async handleOpenPopupRequestConfirmCommandExecution(): Promise<boolean> {
    let canExecuteCommand: boolean = true;
    if (this.showRequestConfirmAction) {
      canExecuteCommand = await this.alertService.presentAlertConfirmOrDismiss(
        this._lblRequestConfirm,
        "",
        this._lblRequestConfirmCommandExecution
      );
    }

    return canExecuteCommand;
  }

  /**
   * Handle check command password if property "PasswordProtected" is enable
   *
   * @returns is password ok
   */
  protected async isCommandPasswordOk(): Promise<boolean> {
    let isPasswordOk: boolean = true;

    if (this.ComponentAPI.properties["PasswordProtected"] === "TRUE") {
      isPasswordOk = await this.popupService.showModalRequestNumericPassword(
        this.ComponentAPI.properties["Password"]
      );
    }

    return isPasswordOk;
  }

  /**
   * Returns true if the value is in the range of shapeLayout conditions
   * @param shapeLayout The ShapeLayout or StateImage to check
   * @param value The value to check
   * @returns
   */
  public isValueIncludedIntoRange(
    shapeLayout: ShapeLayout | StateImage,
    value: string
  ): Boolean {
    try {
      let result: boolean = false;
      let cond1: boolean = false,
        cond2: boolean = false;
      let numericValue: number = Number(value);
      let numericInnerValue: number = Number(shapeLayout.value);

      if (!shapeLayout.rangeOfValues)
        return value.toUpperCase() === shapeLayout.value.toUpperCase();
      if (
        isNaN(numericValue) ||
        (!shapeLayout.valueFrom && isNaN(numericInnerValue))
      ) {
        if (shapeLayout.valueFromIncluded) {
          if (shapeLayout.valueToIncluded) {
            return new RegExp(shapeLayout.value, "gi").test(value);
          } else {
            return new RegExp(shapeLayout.value + "$", "gi").test(value);
          }
        } else {
          if (shapeLayout.valueToIncluded) {
            return new RegExp("^" + shapeLayout.value, "gi").test(value);
          } else {
            return shapeLayout.value.toUpperCase() === value.toUpperCase();
          }
        }
      } else {
        if (shapeLayout.valueFrom) {
          if (shapeLayout.valueFrom === "-") cond1 = true;
          else {
            if (shapeLayout.valueFromIncluded)
              cond1 = Number(shapeLayout.valueFrom) <= numericValue;
            else cond1 = Number(shapeLayout.valueFrom) < numericValue;
          }
          if (shapeLayout.valueTo === "-") cond2 = true;
          else {
            if (shapeLayout.valueToIncluded)
              cond2 = numericValue <= Number(shapeLayout.valueTo);
            else cond2 = numericValue < Number(shapeLayout.valueTo);
          }
          return cond1 && cond2;
        } else {
          result = numericValue == numericInnerValue;
          if (shapeLayout.valueFromIncluded) result = !result;
          return result;
        }
      }
    } catch (exception) {
      this.loggerService.log(
        LogLevel.LOG_ERROR,
        this._logContext,
        this._logContext,
        "isValueIncludedIntoRange()",
        exception
      );
      return false;
    }
  }

  /**
   * Return if generic click action type (clickAction or doubleClickAction) is set or write
   *
   * @param typeClickAction click action type
   * @returns
   */
  protected isClickActionSetValue(typeClickAction: string): boolean {
    return !(
      typeClickAction === ClickActionType.NO_ACTIONS ||
      typeClickAction === ClickActionType.READ ||
      typeClickAction === ClickActionType.POPUP
    );
  }

  /**
   * Handle bit mask elaboration
   *
   * @param currentAddressValue Current Address value
   * @returns
   */
  private handleBitMask(currentAddressValue: string): string {
    let intBitMask = 0;

    if ((this._bitMask as string).startsWith("bin")) {
      intBitMask = parseInt((this._bitMask as string).substring(3), 2);
    } else if ((this._bitMask as string).startsWith("hex")) {
      intBitMask = parseInt((this._bitMask as string).substring(3), 16);
    } else if (!isNaN(Number(this._bitMask))) {
      intBitMask = parseInt(this._bitMask as string);
    }

    if (intBitMask) {
      currentAddressValue = (
        parseInt(currentAddressValue) & intBitMask
      ).toString();
    }

    return currentAddressValue;
  }

  /**
   * Workaround for iOS. When any component is destroyed multiple time, it lose variable-html binding,
   * so you must call ngZone.run to perform update in UI.
   * It works only in iOS
   */
  private updateIosVariable(textComponent: string): void {
    if (this.platform.is("ios")) {
      this.ngZone.run(() => {
        this.text = textComponent;
      });
    }
  }

  /**
   * Check if generic string have inside translated text.
   * If true, then replace translation with specific translated text.
   * Otherwiser return strings
   *
   * @param text
   * @returns
   */
  protected handleTextTranslation(text: string): string {
    if (this.ValueContainsTranslateData(text)) {
      text = this.translateService.TranslateText(text);
    }

    return text;
  }

  private ValueContainsTranslateData(value: string) {
    return value.includes("{{") && value.includes("}}");
  }

  /**
   * Handle generic popup methods
   *
   * @param address
   * @returns
   */
  private async handlePopupMethod(address: Address): Promise<string> {
    let listMethods: Array<AddressMethod> = address.SplitMethods(
      address.loadMethodStringByLanguage(this.translateService.currentLanguage)
    );

    listMethods = [
      ...listMethods,
      {
        name: this._lblRead,
        value: ClickActionType.READ.toString(),
      },
    ];

    let valueToWrite = await this.popupService.showModalAddressMethods(
      this._lblMOp,
      this._lblOp2,
      listMethods
    );

    return (valueToWrite ??= "");
  }

  /**
   * Ineject required service
   *
   * @param injector
   */
  private injectRequiredService(injector: Injector): void {
    this.domSanitizer = injector.get(DomSanitizer);
    this.translateService = injector.get(TranslationService);
    this.scenarioService = injector.get(ScenariosService);
    this.modalController = injector.get(ModalController);
    this.supervisionService = injector.get(SupervisionService);
    this.systemRouterService = injector.get(SystemRouterService);
    this.storageService = injector.get(LocalStorageService);
    this.navController = injector.get(NavController);
    this.addressService = injector.get(AddressService);
    this.alertService = injector.get(AlertService);
    this.translateServiceTraductionService = injector.get(TranslateService);
    this.eventService = injector.get(EventService);
    this.platform = injector.get(Platform);
    this.utilityService = injector.get(UtilityService);
    this.popupService = injector.get(PopupService);
    this.ngZone = injector.get(NgZone);
    this.store = injector.get(Store);
    this.bigService = injector.get(BIGService);
    this.mqttService = this.injector.get(MqttClientService);
    this.validListHandlerService = this.injector.get(ValidListHandlerService);
    this.loggerService = injector.get(LoggerService);
    this.mqttNativeService = injector.get(MqttService);
    this.genericQueryService = injector.get(GenericQueryService);
    this.plantCodeService = injector.get(PlantCodeService);
    this.cardsService = injector.get(CardsService);
  }

  //#region Subscribe to event-service observable
  public subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this.eventService.OnListIsScrolling.subscribe(
        (isSupervisionListScrolling: boolean) => {
          this.isContainingListScrolling = isSupervisionListScrolling;
        }
      )
    );
  }

  public unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }

  //#endregion
}
